import { useApolloClient } from "@apollo/client";
import { useEnvContext } from "context/EnvContext";
import { isPrintMode } from "core/model/utils/urls";
import SealdContextProvider from "core/seald/SealdContext";
import { AppType } from "core/types";
import SpinnerPage, {
  SpinnerPageContainer,
} from "ds_legacy/components/Spinner";
import PrintOverlay from "dsl/atoms/PrintOverlay";
import {
  useConnecterWithLoggedAccount,
  useOnLogout,
} from "reduxentities/hooks";

export default function WebSealdContextProvider({
  app,
  children,
}: {
  app: AppType;
  children: React.ReactNode;
}) {
  const loggedAccount = useConnecterWithLoggedAccount({ cacheOnly: true });
  const envContext = useEnvContext();
  const onLogout = useOnLogout();
  const client = useApolloClient();
  const isPrint = isPrintMode();

  return (
    <SealdContextProvider
      apolloClient={client}
      app={app}
      envContext={envContext}
      Loading={
        isPrint ? (
          <PrintOverlay />
        ) : (
          <SpinnerPageContainer>
            <SpinnerPage id="seald-import-identify" />
          </SpinnerPageContainer>
        )
      }
      loggedAccount={loggedAccount}
      onLogout={onLogout}
    >
      {children}
    </SealdContextProvider>
  );
}
